import React, { PropTypes } from 'react'
import {Card, CardHeader, CardText} from 'material-ui/Card'
import {blue500, red500, grey500} from 'material-ui/styles/colors'

import PowerSettingsNew from 'material-ui/svg-icons/action/power-settings-new'
import PanTool from 'material-ui/svg-icons/action/pan-tool'
import FontDownload from 'material-ui/svg-icons/content/font-download'

const AUTOMATIC_MODE_ROLE = 11
const MANUAL_MODE_ROLE = 12

const getDescription = (mode) => {
  switch (mode) {
    case 1:
      return 'Automático'
    case 2:
      return 'Manual'
    default:
      return 'Desligado'
  }
}

const IconOperationMode = (props) => {
  const {mode} = props
  if (mode === 1) {
    return <FontDownload {...props} color={blue500} />
  }
  if (mode === 2) {
    return <PanTool {...props} color={red500}/>
  }
  return <PowerSettingsNew {...props} color={grey500} />
}

const OperationMode = ({informations, style}) => {
  let mode = 1
  informations.forEach(information => {
    switch (information.role) {
      case AUTOMATIC_MODE_ROLE:
        if (information.updates.length > 0)
        {
          if (information.updates[0].data === 1)
          {
            mode = 1
          }
        }
        break
      case MANUAL_MODE_ROLE:
        if (information.updates.length > 0)
        {
          if (information.updates[0].data === 1) {
            mode = 2
          }
        }
        break
      default:
        return
    }
  })
  return (
    <Card style={{...style}}>
      <CardHeader
        title="Modo de Funcionamento"
        subtitle={getDescription(mode)}
        textStyle={{padding: 0}}
        style={{paddingBottom: 0}}
      />
    <CardText>
      <IconOperationMode style={{height: 'inherit', width: '80%', marginLeft: '10%'}} mode={mode} />
    </CardText>
    </Card>
  )
}

OperationMode.propTypes = {
  informations: PropTypes.array.isRequired
}

export default OperationMode



/** WEBPACK FOOTER **
 ** ./src/components/dashboard/OperationMode.js
 **/